import {createBrowserRouter, redirect} from "react-router-dom";

import AuthGuard from "./auth/AuthGuard";

import Error404 from "./views/sessions/Error";
import sessionsRoutes from "./views/sessions/sessionsRoutes";
import documentWorkspaceRoutes from "./views/document-workspace/documentWorkspaceRoutes";
import organizationRoutes from "./views/organization/organizationRoutes";
import organizationalUnitRoutes from "./views/organizational-unit/organizationalUnitRoutes";
import departmentRoutes from "./views/department/departmentRoutes";
import businessRolesRoutes from "./views/business-role/businessRolesRoutes";
import managementUserRoutes from "./views/management-user/managementUserRoutes";
import documentTypeRoutes from "./views/document-type/documentTypeRoutes";
import automaticFlowRoutes from "./views/workflow-design/automaticFlowRoutes";
import documentRoutes from "./views/create-document/documentRoutes";
import folderRoutes from "./views/folder/folderRoutes";
import personalizedAIRoutes from "./views/personalized-ai/personalizedAIRoutes";
import publicLinkRoutes from "./views/public-link/publicLinkRoutes";
import chatRoutes from "./views/chat/chatRoutes";
import dashboardRoutes from "./views/dashboard/dashboardRoutes";
import assistenteDigitalRoute from "./views/assistente-cobranca/assistenteDigitalRoute";
import designEditRoute from "./views/design-flow/designPageRoute";
import uploadLoteRoutes from "./views/lote-upload/uploadLoteRoutes";
import filterRoutes from "./views/filter/filterRoutes";
import iaChatRoutes from "./views/ia-chat/iaChatRoutes";
import documentFoldersRoutes from "./views/document-folders/document-folder-routes";
import documentLoteRoutes from "./views/document-lote/document-lote-routes";
import docEventRoutes from "./views/document-event/doc-event-routes";

export const protectedRoutes = [
    ...documentWorkspaceRoutes,
    ...organizationRoutes,
    ...organizationalUnitRoutes,
    ...departmentRoutes,
    ...businessRolesRoutes,
    ...managementUserRoutes,
    ...documentTypeRoutes,
    ...automaticFlowRoutes,
    ...documentRoutes,
    ...folderRoutes,
    ...personalizedAIRoutes,
    ...dashboardRoutes,
    ...assistenteDigitalRoute,
    ...designEditRoute,
    ...uploadLoteRoutes,
    ...filterRoutes,
    ...iaChatRoutes,
    ...documentFoldersRoutes,
    ...documentLoteRoutes,
    ...docEventRoutes,
];
const routes = createBrowserRouter([
    {
        element: <AuthGuard/>,
        children: protectedRoutes
    },
    ...sessionsRoutes,
    ...publicLinkRoutes,
    {path: "/", loader: () => redirect("/ia-chat")},
    {path: "*", element: <Error404/>}
]);

export default routes;